import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { RiMoonLine, RiSunLine } from '@remixicon/react';
import { ThemeModeProvider } from '../../theme/mode';
import { uzumDarkTheme, uzumTheme } from '../../theme/uzum';
import { uzumBuiCss, uzumDarkBuiCss } from '../../theme/uzumBui';

const UzumTheme = ThemeBlueprint.make({
  name: 'uzum',
  params: {
    theme: {
      id: 'uzum',
      title: 'Uzum',
      variant: 'light',
      icon: <RiSunLine />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={uzumTheme} themeName="uzum">
          <style>{uzumBuiCss}</style>
          <ThemeModeProvider mode="light">{children}</ThemeModeProvider>
        </UnifiedThemeProvider>
      ),
    },
  },
});

const UzumDarkTheme = ThemeBlueprint.make({
  name: 'uzum-dark',
  params: {
    theme: {
      id: 'uzum-dark',
      title: 'Uzum Dark',
      variant: 'dark',
      icon: <RiMoonLine />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={uzumDarkTheme} themeName="uzum-dark">
          <style>{uzumDarkBuiCss}</style>
          <ThemeModeProvider mode="dark">{children}</ThemeModeProvider>
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [UzumTheme, UzumDarkTheme],
});
